﻿import { DataRequest } from 'shared/data/datarequest';

export class FieldDataSecurity extends DataRequest {
    static $type = 'Web.FieldDataSecurity';

    identifier: string;
    fieldName: string;
    canRead: boolean;
    canWrite: boolean;
}